export default "__VITE_ASSET__BuJ1SdtW__"